const RightArrow = ({ customClass }) => {
  return (
    <button
      className={`group bg-[rgba(255,255,255,0.3)] hover:bg-black border border-solid border-primary absolute w-8 h-8 sm:w-10 sm:h-10 lg:w-[3vw] lg:h-[3vw] translate-y-[-50%] top-1/2  z-50 rounded-full right-4 lg:right-[5vw] ease-out duration-500 ${customClass}`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        className="w-[65%] m-auto fill-primary group-hover:fill-white"
      >
        <path d="M22.7715 16.6667L15.0484 24.3898L15.9997 25.3334L25.333 16L15.9997 6.66669L15.0484 7.61029L22.7715 15.3334H6.66634V16.6667H22.7715Z" />
      </svg>
    </button>
  );
};

export default RightArrow;
